import { gsap, ScrollToPlugin } from "gsap/all";
import {throttle} from 'lodash'
gsap.registerPlugin(ScrollToPlugin);

export default class bodyScroll {


  constructor() {
     header = document.getElementById("header");
  }

  static init() {
      window.addEventListener('scroll', throttle(this.addScrollClass, 50));
  }

  static addScrollClass() {
 
   const scrolled = this.header.offsetTop;

    if (window.pageYOffset > scrolled) {
      document.body.classList.add("scrolled");
    } else {
      document.body.classList.remove("scrolled");
    }
 
  }

}
